const zh_CN = {
  nav_api: "API 文档",
  nav_manageApp: "管理应用",
  nav_signin: "登录",
  nav_signup: "注册",
  manageApp_title: "管理应用",
  manageApp_newApp: "应用名",
  manageApp_appName: "应用名称",
  manageApp_desctiption: "应用描述",
  manageApp_action: "操作",
  manageApp_edit: " 编辑 ",
  manageApp_delete: " 删除 ",
  manageApp_signInTip: "请{signin}后再管理你的应用。",
  manageApp_signInTip_signin: " 登录 ",
  manageApp_noAppTip: "暂无应用程序，请点击右上角“新应用”。",
  deleteApp_title: "删除应用",
  deleteApp_content: "删除后无法恢复，确定要删除此应用吗",
  deleteApp_delete: " 删除 ",
  newApp_title: "新应用",
  newApp_add: " 添加 ",
  newApp_appName: "应用名称",
  newApp_desctiption: "应用描述",
  newApp_appServicesURL: "官方网站地址",
  input_placeholder: "请输入",
  input_copy: "复制",
  tip_appNamerequired: "请输入你的应用名称",
  tip_appNameMax64: "应用名称最多 64 字符",
  tip_appServicesURLMax64: "官方网站地址最多 256 字符",
  tip_redirectURLMax64: "OAuth Redirect URL 最多 256 字符",
  tip_URL: "请输入正确的地址",
  tip_descriptionMax1000: "应用描述最多 1000 字符",
  message_upload300x300: "仅支持上传尺寸为 300px x 300px 的应用图标",
  message_uploadType: "仅能上传 JPG/PNG 文件!",
  message_uploadSize: "文件大小需要小于 2MB！",
  message_copied: "已复制",
  message_createFailed: "添加失败",
  message_deleteFailed: "删除失败",
  message_saveFailed: "保存失败",
  message_resetFailed: "重置失败",
  appSetting_title: "应用设置",
  appSetting_description:
    "我们使用 OAuth 2.0 协议，它允许您的应用直接请求授权用户滴答清单帐户中的私人数据，而无需获取密码。",
  appSetting_reset: "重置",
  button_cancel: "取消",
  button_reset: "重置",
  reset_title: "确定要重置你的 Client Secret 吗?",
  reset_content: "重置操作不能撤销",
  appSetting_appName: "应用名称",
  appSetting_desctiption: "应用描述",
  appSetting_appServicesURL: "官方网站地址",
  appSetting_appIcon: "应用图标",
  appSetting_save: "保存",
  appSetting_back: "返回",
  appSetting_upload: "上传"
};
export default zh_CN;
